import gql from 'graphql-tag';

export default gql`
    query GetAllLofasFiltered($input: String) {
        getAllLofasFiltered(input: $input) {
            id
            lofaName
            addressStreet
            city
            zip
            phoneNumber
            jdeNumber
            description
            stateId
            utm
            latitude
            longitude
            entryKioskLatitude
            entryKioskLongitude
            directions
            geoFenceType
            geoFenceRadius
            polygonCoordinates {
                lat
                lng
            }
            entryKioskPolygonCoordinates {
                lat
                lng
            }
            regionId
            districtId
            kioskGeoFenceRadius
            isTCSEnabled
        }
    }
`;
